import { z } from 'zod';
import {
  longTextSchema,
  projectIdSchema,
  safeUrlSchema,
  tagsSchema,
  titleSchema,
  visibilitySchema,
} from './common.js';
import { IMPORTANCE_VALUES, SOURCE_TYPES } from '../../types/link.js';

export const linkInputSchema = z.object({
  title: titleSchema,
  url: safeUrlSchema,
  sourceType: z.enum(SOURCE_TYPES as readonly [string, ...string[]]),
  domain: z.string().max(253),
  summary: longTextSchema(2000, '概要'),
  userComment: longTextSchema(2000, '共有コメント'),
  importance: z.enum(IMPORTANCE_VALUES as readonly [string, ...string[]]),
  tags: tagsSchema,
  visibility: visibilitySchema,
  thumbnailUrl: z.string().url().optional(),
  channelName: z.string().trim().max(256, 'チャンネル名は256文字以内').optional(),
  projectId: projectIdSchema,
});

export type LinkInputSchema = z.infer<typeof linkInputSchema>;
